import React, { createContext, useState, useContext } from "react";
import { char, code } from "../utils";
import { authCRUD } from "../actions/auth";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [otp, setOtp] = useState({});
  const [email, setEmail] = useState(null);
  const [name, setName] = useState(null);
  const [type, setType] = useState(null);

  const getOtp = (data) => {
    setOtp({
      otp: code.otpCode(),
      time: code.lifeTime(data.time),
      isOTP: true,
    });
    setEmail(data.email);
    setName(data.name);
    setType(data.type);
  };

  const otpCode = otp.otp;

  if (email && name && type === "verification") {
    const emailData = {
      email: email,
      name: name,
      otp_code: otpCode,
    };
    authCRUD
      .sendOTPEmail(emailData)
      .then(() => {})
      .catch(() => {});
  } else if (email && name && type === "login") {
    const emailData = {
      email: email,
      name: name,
      otp_code: otpCode,
    };
    authCRUD
      .sendOTPEmail(emailData)
      .then(() => {})
      .catch(() => {});
  }

  return (
    <AuthContext.Provider value={{ otp, getOtp }}>
      {children}
    </AuthContext.Provider>
  );
};
